import { SCOPE } from './types';

export { SCOPE };

export const selector = state => state[SCOPE];

export { default as reducer } from './reducer';
